import { IconProgressCheck, IconToggleLeftFilled, IconToggleRightFilled, IconX } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Badge, Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import TableComponent from '../../../components/DataTable/TableComponent';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { dateTimeConverter } from '../../../utils/dateTimeConverter';
import IconButton from '../../../components/Buttons/IconButton';

const SubmittedIssueByUserModal = ({ userData }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    const statusList = [
        {
            id: null,
            name: "All"
        }, {
            id: 1,
            name: "Pending"
        }, {
            id: 2,
            name: "Resolved"
        }
    ]

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    const getList = async () => {
        loadingShow();
        let resp = await getApi(urlApi.issueListOfUser + userData?._id + "?page=" + activePage + "&limit=" + perPage);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data?.items,
                totalCount: resp.data?.count
            });
            handleShow();
        } else {
            setTableData({
                data: [],
                totalCount: 0
            })
            toast.error(resp?.message)
        }
    }

    useEffect(() => {
        if (show) {
            getList();
        }
        return () => {

        };
    }, [activePage, perPage]);

    async function updateStatus(id, status) {
        loadingShow();
        let resp = await getApi(`${urlApi.updateIssueStatusOfUser}${userData?._id}/${id}/${status}`);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getList();
        } else {
            toast.error(resp.message);
        }
    }

    const columns = [
        { name: "Sl. No", center: "true", width: "60px", selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Issue", center: "true", selector: (row) => row?.issue, cell: (row) => (
                <p className=''>{row?.issue}</p>
            ),
        },
        { name: "Description", center: "true", selector: (row) => row?.description, cell: (row) => row?.description || "--", },
        {
            name: "Created", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <p>{dateTimeConverter(row?.createdAt)}</p>
        },
        {
            name: "Updated", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <p>{dateTimeConverter(row?.updatedAt)}</p>
        },
        {
            name: "Status", center: "true", selector: (row) => row?.status, cell: (row) =>
                <div className='flex !gap-3 flex-wrap'>
                    {row?.status == 1 && <ConfirmationModal
                        buttonComponent={<IconButton icon={<IconProgressCheck stroke={3} className='text-green-600 cursor-pointer transition-all' />} />}
                        confirmationText={`Are You Sure Want Mark Resolve this Issue ?`}
                        onConfirm={() => updateStatus(row?._id, 2)}
                    />}
                    {row?.status != 1 && <Badge bg={statusList?.find(item => item.id == row?.status)?.color}>{statusList?.find(item => item.id == row?.status)?.name}</Badge>}
                </div>
        }
    ]

    return (
        <div>
            <button className='bg-yellow-700 !px-5 !py-1.5 rounded-full text-sm text-white' onClick={getList}>Submitted Issues</button>
            <Modal show={show} onHide={handleClose} size='xl' >
                <Modal.Body className=' rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold"> Issues Of {userData?.name}</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <TableComponent
                        columns={columns}
                        data={tableData.data}
                        totalRows={tableData.totalCount}
                        isPagination={true}
                        handlePageChange={(e) => handlePageChange(e)}
                        handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

                </Modal.Body>
            </Modal>
        </div>
    )
}

export default SubmittedIssueByUserModal